<template>
  <v-container fluid class="_pagina_cliccatori">
		<template v-if="computedAmIAdmin">
			
			<!--<v-switch-->
			<!--	v-model="testSwitch"-->
			<!--	inset-->
			<!--	color="#7cc35d"-->
			<!--&gt;</v-switch>-->
			
			<!--<v-btn rounded @click="cliccatori.find(cliccatore => cliccatore.id == 1).is_active = true">-->
			<!--	test switch-->
			<!--</v-btn>-->
			
			<v-navigation-drawer
				v-if="mostraNavigationDrawer"
				permanent
				:style="`background-color:${scdColor}; height:100%;`"
				class="float-left mr-2"
				data-tour-step-cliccatori="1a"
			>
				<v-list-item>
					<v-list-item-content class="pb-0">
						<v-list-item-title class="white--text" style="padding:4px;">
							
							<v-icon
								@click="mostraNavigationDrawer = false"
								color="white"
							>
								mdi-menu
							</v-icon>
							
							<div class="text-center mb-4 _semi_bold">
								<div>Cliccatori attivi</div>
								<v-progress-circular
									v-if="isLoadingInfoCliccatoriAttivi
									|| isLoadingAttivaDisattivaSquadra
									|| isLoadingAttivaDisattivaCliccatore"
									size="14"
									width="1"
									indeterminate color="white"
								></v-progress-circular>
								<div v-else>
									{{ infoCliccatoriAttivi.attivi }} / {{ infoCliccatoriAttivi.max_cliccatori_disponibili }}
								</div>
							</div>

							<v-tooltip v-if="!computedHasTeamsEnabled" right>
								<template v-slot:activator="{ on }">
									<v-btn rounded block depressed style="cursor:not-allowed; text-transform:none; color:#434343; letter-spacing:0.5px;" color="white" v-on="on">Crea nuova squadra<v-icon class="ml-1">add</v-icon></v-btn>
								</template>
								<span class="_semi_bold">Il tuo pacchetto non prevede la possibilità di creare squadre</span>
							</v-tooltip>
							<div v-else data-tour-step-cliccatori="1b" >
								<v-btn rounded block depressed class="_semi_bold" style="text-transform:none; color:#434343; letter-spacing:0.5px;" @click="openEditTeamDialog(true)"  color="white">Crea nuova squadra<v-icon style="font-size:15px;" class="ml-1">add</v-icon></v-btn>
							</div>
							<div class="d-flex justify-center pt-4 pb-1 _semi_bold" style="border-bottom:2px solid white;">Squadre</div>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-row v-if="isLoadingTeams" class="mt-4" justify="center">
					<v-progress-circular size="14" width="1" indeterminate color="white"></v-progress-circular>
				</v-row>
				<v-list v-else dense :disabled="isLoadingCliccatori">
					<v-list-item-group v-model="indexTeamSelezionato" color="white">
						<v-list-item v-for="(team, index) in teams" :key="index">
							<v-list-item-content>
								<v-list-item-title class="white--text">
									<v-tooltip right>
										<template v-slot:activator="{ on }">
											<span class="_semi_bold" style="font-size:14px;" v-on="on">{{ team.nome }}</span>
										</template>
										<span>{{ team.nome }}</span>
									</v-tooltip>
								</v-list-item-title>
								<v-list-item-subtitle>
									<span
										class="white--text"
										style="font-size: 12px;"
									>
										{{ team?.team_leader?.nome }} {{ team?.team_leader?.cognome }}
									</span>
								</v-list-item-subtitle>
								<v-list-item-subtitle>
									<span
										class="white--text"
										style="font-size: 12px;"
									>
										{{ team.numero_cliccatori }} Cliccatori
									</span>
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action>
								<template v-if="team.id > 0">
									<v-switch
										v-model="team.is_active"
										inset
										color="#7cc35d"
										@change="attivaDisattivaSquadra(team.id, team.is_active, team)"
										@click="myStopPropagation"
									></v-switch>
								</template>
							</v-list-item-action>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-navigation-drawer>
		</template>

		<!--flex:1 1 auto;-->
		<!--style="margin-left:11px;"-->
		<v-row>
			<v-col>
				<div data-tour-step-cliccatori="1" class="_box">
					<div class="_box_title">
						<v-icon
							v-if="!mostraNavigationDrawer"
							@click="mostraNavigationDrawer = true"
							color="white"
							class="float-left ml-3"
						>
							mdi-menu
						</v-icon>
						Dati Squadra
					</div>
					<div class="_box_info _dati_squadra align-center justify-space-between">
						<div style="padding-right:15px;">
							<div>Nome: <span :style="`color:${scdColor}`">{{ teamSelezionato.nome }}</span></div>
							<div v-if="teamSelezionato.id != -1">Coordinatore:
								<!-- Se sono nel Team0 allora imposto l'admin come coordinatore, altrimenti il teamleader se impostato, altrimenti "(Nessuno)" -->
								<span v-if="(teamSelezionato == null || teamSelezionato.id == 0) && computedAmIAdmin" :style="`color:${scdColor}`">{{computedUsername}}</span>
								<span v-else-if="teamSelezionato != null && teamSelezionato.team_leader != null" :style="`color:${scdColor}`">{{teamSelezionato.team_leader.username}}</span>
								<span v-else-if="teamSelezionato != null && !isLoadingTeams" style="color: red">(Nessuno)</span>
							</div>
						</div>
						<div class="d-flex align-center">
							<v-btn
								v-if="teamSelezionato.id > 0 && computedAmIAdmin && computedHasTeamsEnabled && !isLoadingTeams"
								:color="scdColor"
								style="text-transform:none;"
								small
								depressed
								rounded
								class="white--text _semi_bold mr-3"
								@click="openEditTeamDialog(false)"
							>
								Modifica dati squadra
							</v-btn>
							<v-btn
								v-if="teamSelezionato.id != -1 && computedHasTeamsEnabled && !isLoadingTeams && bandoConSimulazioni"
								:color="scdColor"
								style="text-transform:none;"
								small
								depressed
								rounded
								class="white--text _semi_bold"
								@click="showStatsSquadra(teamSelezionato.id)"
							>
								Visualizza statistiche squadra
							</v-btn>
						</div>
					</div>
				</div>

				<div :style="`background-color:${scdColor}; height:5px; margin-bottom:5px`"></div>

				<div class="d-flex align-center">
					<div data-tour-step-cliccatori="2">
						<v-btn
							rounded
							depressed
							style="text-transform:none; letter-spacing:0.5px;"
							:color="scdColor"
							class="_semi_bold white--text"
							@click="openEditCliccatoreDialog(true, null)"
							:disabled="isLoadingTeams
								|| isLoadingCliccatori
								|| cliccatori.length >= teamSelezionato.max_cliccatori
								|| isLoadingInfoCliccatoriAttivi
								|| isLoadingAttivaDisattivaSquadra
								|| isLoadingAttivaDisattivaCliccatore"
						>
							Crea nuovo cliccatore
							<v-icon class="ml-1">add</v-icon>
						</v-btn>
					</div>
					
					<div v-if="computedClienteClickdayIt && amIAdminOrTeamleader">
						<v-btn
							rounded
							depressed
							style="text-transform:none; letter-spacing:0.5px;"
							:color="scdColor"
							class="_semi_bold white--text ml-3"
							@click="apriFiltriDialog()"
							:disabled="isLoadingTeams || isLoadingCliccatori"
						>
							Filtri
							<v-icon
								small
								class="ml-1"
							>
								filter_alt
							</v-icon>
						</v-btn>
							
						<!-- Badge visualizzato solo se numFiltriAttivi > 0 -->
						<v-chip
							class="ml-2"
						 	:color="numFiltriAttivi > 0 ? 'green' : 'grey'"
							text-color="white"
						>
							<v-avatar
								left
								:color="numFiltriAttivi > 0 ? 'green' : 'grey'"
								class="darken-2"
							>
								{{ numFiltriAttivi }}
							</v-avatar>
							Filtri applicati
						</v-chip>
						<v-icon
							v-if="numFiltriAttivi > 0"
							color="gray"
							title="Rimuovi tutti i filtri"
							@click="resetFiltri"
						>
							mdi-close-circle
						</v-icon>
					</div>
					
					<v-btn
						v-if="computedClienteClickdayIt && computedAmIAdmin"
						@click="apriGestioneIscrizioneInMassaAlClickdayDialog()"
						class="_semi_bold white--text ml-3"
						:color="scdColor"
						rounded
						depressed
						style="text-transform:none; letter-spacing:0.5px;"
						:disabled="isLoadingCliccatori || isLoadingTeams"
						:loading="isLoadingIscrizione"
					>
						Iscrizione al Click Day
						<v-icon class="ml-1">mdi-gesture-tap</v-icon>
					</v-btn>
					<v-spacer></v-spacer>
					
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon color="primary" v-bind="attrs" v-on="on" @click="dialogVisibilitaColonne = true">
								<v-icon>mdi-view-column</v-icon>
							</v-btn>
						</template>
						<span>Clicca qui per selezionare le colonna da visualizzare e in cui effettuare la ricerca</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on">
								<v-switch v-model="isRicercaMatchEsattoAbilitato" class="mr-3"></v-switch>
							</div>
						</template>
						<span>Attiva questo interruttore per ricercare tramite corrispondenza esatta</span>
					</v-tooltip>

					<v-text-field
						outlined
						dense
						hide-details
						autocomplete="search-cliccatore"
						v-model="searchCliccatore"
						append-icon="search"
						class="pt-1 mb-2"
					>
						<template v-slot:label>
							<span style="font-size:86%;">{{ computedAmIAdmin && computedHasTeamsEnabled ? 'Cerca tra i cliccatori della squadra' : 'Cerca tra i cliccatori' }}</span>
						</template>
					</v-text-field>
				</div>

				<v-dialog v-model="dialogVisibilitaColonne" max-width="400px">
					<v-card>
						<v-card-title>
							Configura colonne
							<v-btn icon @click="dialogVisibilitaColonne = false" class="ml-auto">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text>
							<!-- Nota: nel seguente è stato aggiunta la funzione perché il v-model si collega al risultato del computed, mentre la funzione modifica l'array di headers originale -->
							<v-checkbox v-for="header in computedHeadersCliccatori" :key="header.value" 
													v-model="header.isVisibile"
													@change="modificaVisibilitaColonna(header.value, $event)" :label="header.text"
													hide-details class="m-0"/>
						</v-card-text>
						<!-- <v-card-actions>
							<v-spacer />
							<v-btn color="primary" @click="dialogVisibilitaColonne = false">Chiudi</v-btn>
						</v-card-actions> -->
					</v-card>
				</v-dialog>

				<v-data-table
					style="background-color:#eeeeee"
					class="cliccatori-data-table
					data-tour-step-cliccatori-3
					data-tour-step-cliccatori-4
					data-tour-step-cliccatori-5
					data-tour-step-cliccatori-6
					"
					:headers="computedHeadersVisibiliCliccatori"
					:items="cliccatori"
					item-key="id"
					:search="searchCliccatore"
					:sort-by="cliccatoriSortBy"
					:sort-desc="cliccatoriSortDesc"
					:hide-default-footer="isLoadingCliccatori"
					:loading="isLoadingTeams || isLoadingCliccatori"
					loading-text="Caricamento..."
					no-data-text="Nessun Cliccatore trovato"
					no-results-text="Nessun Cliccatore di questa Squadra corrisponde alla ricerca effettuata"
					:footer-props="{'items-per-page-options':[5, 15, 30, 100, 200, 500, -1], 'items-per-page-text': 'Cliccatori per pagina'}"
					:options="{ itemsPerPage: 200 }"
					:custom-filter="customSearch"
					fixed-header
					height="calc(100vh - 325px)"
					dense
				>

					<!-- Personalizzazione headers -->
					<template v-slot:header.win_score_attuale_o_vincenti_perc_ultime_x="{ header }">
						<div class="d-flex align-center">
							{{ header.text }}
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										small
										color="primary"
										class="ml-1"
										v-bind="attrs"
										v-on="on"
									>
										mdi-information
									</v-icon>
								</template>
								<span>Mostra la percentuale di simulazioni vinte tra le ultime {{ minimoSimulazioniSelezione }}</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:header.win_score="{ header }">
						<div class="d-flex align-center">
							{{ header.text }}
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										small
										color="primary"
										class="ml-1"
										v-bind="attrs"
										v-on="on"
									>
										mdi-information
									</v-icon>
								</template>
								La soglia in percentuale del Win Score migliore una volta raggiunta non può più diminuire
							</v-tooltip>
						</div>
					</template>
					
					<template v-slot:header.vincenti_ultime_x="{ header }">
						<div class="d-flex align-center">
							{{ header.text + " " + minimoSimulazioniSelezione }}
						</div>
					</template>
					<template v-slot:header.perdenti_ultime_x="{ header }">
						<div class="d-flex align-center">
							{{ header.text + " " + minimoSimulazioniSelezione }}
						</div>
					</template>
					<template v-slot:header.abbandonate_perc_ultime_x="{ header }">
						<div class="d-flex align-center">
							{{ header.text + " " + minimoSimulazioniSelezione }}
						</div>
					</template>
					<template v-slot:header.tempo_medio_ultime_x="{ header }">
						<div class="d-flex align-center">
							{{ header.text + " " + minimoSimulazioniSelezione }}
						</div>
					</template>

					<!--:hide-default-header="true"-->

					<!--<template v-slot:header.username="{ header }">-->
					<!--	Cliccatore-->
					<!--</template>-->

					<!--<template v-slot:header.vincenti_ultime_x="{ header }">-->
					<!--	<span v-if="gamingAbilitato" >-->
					<!--		<span :style="`color:${scdOrange}`">GAME SCORE</span>-->
					<!--		<span>Vinte ultime 100</span>-->
					<!--	</span>-->
					<!--	<span v-else>Vinte tra le ultime 100</span>-->
					<!--</template>-->

					<!--<template-->
					<!--  v-slot:header="{-->
					<!--		props: {-->
					<!--			headers,-->
					<!--			options: {-->
					<!--				-->
					<!--			},-->
					<!--		}-->
					<!--	}"-->
					<!--&gt;-->
					<!--  <thead>-->
					<!--    <tr>-->
					<!--      <th>-->
					<!--        Cliccatore-->
					<!--      </th>-->
					<!--      <th v-if="bandoConSimulazioni" style="width:83px;">-->
					<!--        Simulazioni<br>eseguite-->
					<!--      </th>-->
					<!--      <th v-if="bandoConSimulazioni" style="width:79px;">-->
					<!--        &lt;!&ndash;<span v-if="gamingAbilitato">&ndash;&gt;-->
					<!--        &lt;!&ndash;  <span :style="`color:${scdOrange}`">GAME SCORE</span><br>&ndash;&gt;-->
					<!--        &lt;!&ndash;  <span>Vinte ultime 100</span>&ndash;&gt;-->
					<!--        &lt;!&ndash;</span>&ndash;&gt;-->
					<!--        &lt;!&ndash;<span v-else>Vinte tra le ultime 100</span>&ndash;&gt;-->
					<!--        <span>Vinte tra le ultime 100</span>-->
					<!--      </th>-->
					<!--      <th v-if="bandoConSimulazioni" style="width:81px;">-->
					<!--        Perse tra le<br>ultime 100-->
					<!--      </th>-->
					<!--      <th v-if="bandoConSimulazioni" style="width:117px;">-->
					<!--        Abbandonate tra<br>le ultime 100-->
					<!--      </th>-->
					<!--      <th v-if="bandoConSimulazioni" style="width:118px;">-->
					<!--        Tempo medio tra<br>le ultime 100-->
					<!--      </th>-->
					<!--			<th v-if="bandoConSimulazioni && computedClienteClickdayIt" style="width:60px;">-->
					<!--				Win Score-->
					<!--			</th>-->
					<!--      <th  class="text-center" style="width:75px;">-->
					<!--        Stato-->
					<!--      </th>-->
					<!--      <th class="text-center">-->
					<!--        Azioni-->
					<!--      </th>-->
					<!--    </tr>-->
					<!--  </thead>-->
					<!--</template>-->

					<template slot="item" slot-scope="props">
						<tr class="_table_row">
							<!-- La seguente colonna dev'essere mostrata solo se il team è -1 (=Tutti i cliccatori) -->
							<td v-if="teamSelezionato.id == -1 && checkHeaderIsVisibile('team.nome')">
								<span v-if="props.item.team">{{ props.item.team.nome }}</span>
								<span v-else></span>
							</td>
							<td v-if="checkHeaderIsVisibile('username')">
								<div class="d-flex align-center" style="font-size: 12px;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<!--<v-img v-if="gamingAbilitato == 1 && bandoConSimulazioni" v-on="on" :src="`/img/livelli_gaming/${numeroLivello(props.item.vincenti_ultime_x)}.png`" class="mr-3" max-width="30" contain></v-img>-->
											<!--<v-icon v-else color="#434343" class="mr-2" dark v-on="on">{{ props.item.ruolo == 'Admin' ? 'account_box' : props.item.ruolo == 'Teamleader' ? 'person' : 'person_outline' }}</v-icon>-->
											<v-icon color="#434343" class="mr-2" dark v-on="on">{{ props.item.ruolo == 'Admin' ? 'account_box' : props.item.ruolo == 'Teamleader' ? 'person' : 'person_outline' }}</v-icon>
										</template>
										<span>{{ props.item.ruolo == 'Admin' ? 'Amministratore' : props.item.ruolo == 'Teamleader' ? 'Coordinatore' : 'Cliccatore' }}</span>
									</v-tooltip>
									<div class="d-flex flex-column">
										<div>{{ props.item.username }}</div>
										<small style="font-weight:400;">{{ props.item.email }}</small>
										<!--<small style="font-weight:400;">{{ props.item.codice_cliccatore }}</small>-->
									</div>

								</div>
							</td>
							<!-- <td v-if="gamingEnabled == 1">
								{{ props.item.miglior_punteggio != -1 ? props.item.miglior_punteggio + '%' : '-'}}
							</td> -->
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('codice_cliccatore')">
								{{ props.item.codice_cliccatore }}
							</td>
							<td v-if="checkHeaderIsVisibile('nome')">
								{{ props.item.nome }}
							</td>
							<td v-if="checkHeaderIsVisibile('cognome')">
								{{ props.item.cognome }}
							</td>
							<td v-if="checkHeaderIsVisibile('cellulare')">
								{{ props.item.cellulare }}
							</td>
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('simulazioni_totali')">
								{{ props.item.simulazioni_totali === null ? '0' : props.item.simulazioni_totali }}
							</td>
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('vincenti_ultime_x')">
								<!--<span :style="`color:${scdOrange}`">-->
									{{ props.item.vincenti_ultime_x === null ? '0' : props.item.vincenti_ultime_x }}
								<!--</span>-->
							</td>
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('perdenti_ultime_x')">
								{{ props.item.perdenti_ultime_x === null ? '0' : props.item.perdenti_ultime_x }}
							</td>
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('abbandonate_perc_ultime_x')">
								{{ props.item.abbandonate_perc_ultime_x === null ? '0%' : props.item.abbandonate_perc_ultime_x + "% (" + props.item.abbandonate_ultime_x + ")" }}
							</td>
							<td v-if="bandoConSimulazioni && checkHeaderIsVisibile('tempo_medio_ultime_x')">
								{{ props.item.tempo_medio_ultime_x === null ? '0' : props.item.tempo_medio_ultime_x }}
							</td>
							<!-- <td>
								{{ props.item.tempo_medio === null ? '0' : props.item.tempo_medio}}
							</td> -->
							<td v-if="bandoConSimulazioni && computedClienteClickdayIt && checkHeaderIsVisibile('win_score_attuale_o_vincenti_perc_ultime_x')">
								<span :style="`color:${scdOrange}`">
									{{ props.item.win_score_attuale_o_vincenti_perc_ultime_x === null ? '-' : `${props.item.win_score_attuale_o_vincenti_perc_ultime_x} %` }}
								</span>
							</td>
							<td v-if="bandoConSimulazioni && computedClienteClickdayIt && checkHeaderIsVisibile('win_score')">
								<span :style="`color:${scdOrange}`">
									{{ props.item.win_score === null ? '-' : `${props.item.win_score} %` }}
								</span>
							</td>
							<td v-if="bandoConSimulazioni && computedClienteClickdayIt && checkHeaderIsVisibile('dataora_superamento_selezione')">
								{{ props.item.dataora_superamento_selezione === null ? '-' : (computedDateTimeWithoutSeconds(props.item.dataora_superamento_selezione) != null ? computedDateTimeWithoutSeconds(props.item.dataora_superamento_selezione) : 'ND') }}
							</td>
							<td v-if="computedClienteClickdayIt && checkHeaderIsVisibile('posizione_classifica')">
								{{ props.item.posizione_classifica === null ? '-' : props.item.posizione_classifica + "°" }}
							</td>
							<td v-if="computedClienteClickdayIt && checkHeaderIsVisibile('ultimo_accesso')">
								{{ props.item.ultimo_accesso === null ? '-' : computedDateWithoutTime(props.item.ultimo_accesso) }}
							</td>
							<td v-if="checkHeaderIsVisibile('stato')">
								<v-switch
									v-model="props.item.is_active"
									inset
									color="#7cc35d"
									@change="attivaDisattivaCliccatore(props.item.id, props.item.is_active)"
									:disabled="isLoadingAttivaDisattivaCliccatore || isLoadingInfoCliccatoriAttivi"
									class="my-2"
									hide-details
								></v-switch>
							</td>
							<td v-if="checkHeaderIsVisibile('actions')">
								<!--<div>-->
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<!-- ho tolto mb-2 -->
											<v-btn
												:color="scdColor"
												style="color:white; text-transform:none;"
												class="_semi_bold"
												small
												depressed
												rounded
												@click="openEditCliccatoreDialog(false, props.item)"
												v-on="on"
											>
												<v-icon size="20">edit</v-icon>
												<!--Modifica-->
											</v-btn>
										</template>
										<span>{{ computedAmIAdmin ? 'Modifica profilo e squadra del cliccatore' : 'Modifica profilo del cliccatore' }}</span>
									</v-tooltip>

									<v-tooltip v-if="bandoConSimulazioni" bottom>
										<template v-slot:activator="{ on }">
											<!-- ho tolto mb-2 -->
											<v-btn
												:color="scdColor"
												style="color:white; text-transform:none;"
												class="_semi_bold"
												small
												depressed
												rounded
												@click="showStatsCliccatore(props.item.id)"
												v-on="on"
											>
												<v-icon size="25">show_chart</v-icon>
												<!--Statistiche-->
											</v-btn>
										</template>
										<span>Visualizza le statistiche del cliccatore</span>
									</v-tooltip>
								<!--</div>-->

								<!--<div class="mt-2">-->
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												:color="scdColor"
												style="color:white; text-transform:none;"
												class="_semi_bold"
												small
												depressed
												rounded
												@click="showDatiCliccatore(props.item.id)" v-on="on"
											>
											<!-- <v-btn :color="scdColor" style="color:white; text-transform:none;" class="_semi_bold" x-small depressed rounded @click="computedClienteClickdayIt ? popUpDatiCliccatore(props.item.id, true) : sidebarDatiCliccatore(props.item.id)" v-on="on"> -->
											<!--	Dati Cliccatore-->
												<v-icon size="20">wysiwyg</v-icon>
											</v-btn>
										</template>
										<span>Visualizza i Dati Personali del cliccatore</span>
									</v-tooltip>
								
									<v-tooltip v-if="gamingAbilitato && bandoConSimulazioni" bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												:color="scdColor"
												style="color:white; text-transform:none;"
												class="_semi_bold"
												small
												depressed
												rounded
												@click="showGamingCliccatore(props.item.id)"
												v-on="on"
											>
												<v-icon size="20">mdi-gamepad-variant-outline</v-icon>
												<!--Gaming-->
											</v-btn>
										</template>
										<span>Visualizza il progresso del cliccatore</span>
									</v-tooltip>
								<!--</div>-->

								<!-- <v-row class="justify-start">
									<v-tooltip v-if="gamingEnabled" bottom>
										<template v-slot:activator="{ on }">
											<v-btn :color="scdColor" class="mb-2 mr-2" x-small outlined @click="showGamingCliccatore(props.item.id)" v-on="on">
												Gaming
											</v-btn>
										</template>
										<span>Visualizza il progresso del cliccatore</span>
									</v-tooltip>
									<v-tooltip v-if="distribuzioneDatiAziendeEnabled" bottom>
										<template v-slot:activator="{ on }">
											<v-btn :color="scdColor"  style="color:white; text-transform:none;" class="mb-2" x-small depressed rounded @click="showDatiAziendaCliccatore(props.item.id)" v-on="on">
												Dati Clickday
											</v-btn>
										</template>
										<span>Visualizza dati azienda assegnata</span>
									</v-tooltip>
								</v-row> -->
								
							</td>
						</tr>
					</template>
					<template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
						{{ pageStart }} - {{ pageStop }} di {{ itemsLength }}
					</template>
					<template v-slot:footer.prepend>
						<div class="d-flex align-center">
							<v-btn
								v-if="(computedAmIAdmin || computedAmITeamleader) && computedClienteClickdayIt"
								:color="scdColor"
								class="white--text mr-3"
								@click="downloadCsv()"
								rounded
								depressed
								small
							>
								Scarica CSV
							</v-btn>
						</div>
					</template>
				</v-data-table>

			</v-col>
		</v-row>

    <v-dialog v-model="isCliccatoreDialogOpen" max-width="900" persistent>
      <v-card class="pa-6">
        <v-card-title class="headline">
          <span v-if="isNewCliccatore">Crea nuovo cliccatore</span>
          <span v-else>Profilo Cliccatore: {{toEditCliccatore.username}}</span>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isCliccatoreDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="cliccatoreForm" v-model="validCliccatoreForm">
						<v-row class="mt-3">
							<v-col class="py-0">
								<v-text-field
									v-model="toEditCliccatore.username"
									autocomplete="new-username"
									label="Scegli un username *"
									:rules="[vincoli.required, vincoli.username, vincoli.notEmail]"
									outlined
									dense
								></v-text-field>
							</v-col>
							<v-col class="py-0">
								<!--:append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"-->
								<!--@click:append="showPasswordInput = !showPasswordInput"-->
								<v-text-field
									v-model="toEditCliccatore.passwordNC"
									autocomplete="new-password"
									:type="showPasswordInput ? 'text' : 'password'"
									:label="isNewCliccatore ? 'Scegli una password *' : 'Cambia Password'"
									:rules="isNewCliccatore ? [vincoli.required, vincoli.password] : [vincoli.password]"
									outlined
									dense
								>
									<template v-slot:append>
										<v-icon
											@click="showPasswordInput = !showPasswordInput"
											class="mr-1"
										>
											{{ showPasswordInput ? 'visibility_off' : 'visibility' }}
										</v-icon>
										<v-icon @click="generaPassword()">mdi-lock-reset</v-icon>
									</template>
								</v-text-field>
								
								<!--<v-text-field-->
								<!--	v-else-->
								<!--	v-model="toEditCliccatore.passwordNC"-->
								<!--	autocomplete="new-password"-->
								<!--	:type="showPasswordInput ? 'text' : 'password'"-->
								<!--	:append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"-->
								<!--	label="Cambia Password" :rules="[vincoli.password]"-->
								<!--	@click:append="showPasswordInput = !showPasswordInput"-->
								<!--	outlined-->
								<!--	dense-->
								<!--&gt;</v-text-field>-->
							</v-col>
						</v-row>
	          <v-row>
		          <v-col cols="6" class="py-0">
			          <v-text-field
				          v-model="toEditCliccatore.nome"
				          autocomplete="none"
				          label="Nome del cliccatore (opzionale)"
				          outlined
				          dense
			          ></v-text-field>
		          </v-col>
		          <v-col cols="6" class="py-0">
			          <v-text-field
				          v-model="toEditCliccatore.cognome"
				          autocomplete="none"
				          label="Cognome del cliccatore (opzionale)"
				          outlined
				          dense
			          ></v-text-field>
		          </v-col>
	          </v-row>
						<v-row>
							<v-col cols="6" class="py-0">
								<v-text-field
									v-model="toEditCliccatore.email"
									autocomplete="new-email"
									label="Email del cliccatore (opzionale)"
									:rules="[vincoli.email]"
									outlined
									dense
								></v-text-field>
							</v-col>
							<v-col cols="6" class="py-0">
								<v-text-field
									v-model="toEditCliccatore.cellulare"
									autocomplete="new-cellulare"
									label="Cellulare (opzionale)"
									:rules="[vincoli.numero_cellulare_cl]"
									outlined
									dense
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="6" class="py-0">
								<v-text-field
									type="number"
									max="65535"
									v-model="toEditCliccatore.codice_cliccatore"
									autocomplete="codice-cliccatore"
									label="Codice cliccatore (opzionale)"
									outlined
									dense
									:rules="[ v => v >= 0 && v <= 65535 || 'Valori consentiti: minimo 0, massimo 65535' ]"
								>
									<template v-slot:append>
										<v-tooltip bottom :color="scdColor">
											<template v-slot:activator="{ on }">
												<v-icon v-on="on" :color="scdColor">
													info
												</v-icon>
											</template>
											Puoi assegnare a questo cliccatore anche un codice numerico facoltativo per aiutarti a distinguerlo dagli altri
										</v-tooltip>
									</template>
								</v-text-field>
							</v-col>
							<v-col
								v-if="computedAmIAdmin && computedHasTeamsEnabled && !isNewCliccatore && toEditCliccatore.ruolo != 'Admin'"
								cols="6" class="py-0"
							>
								<v-select
									:items="teamsSenzaTutteLeSquadreComputed"
									v-model="toEditCliccatore.team_id"
									item-text="nome"
									item-value="id"
									label="Squadra di appartenenza *"
									:rules="[vincoli.required]"
									outlined
									dense
								></v-select>
							</v-col>
						</v-row>
						<v-row v-if="isNewCliccatore">
							<div :style="'color: ' + scdColor">
								<b>Se inserisci l'indirizzo email del cliccatore gli invieremo un messaggio con le credenziali di accesso</b>
							</div>
							<template v-if="isProvaGratuita && computedClienteClickdayIt">
								<div class="error--text mt-5">
									L'indirizzo email è associato ad una prova gratuita, se vuoi disattivarlo spunta la casella e clicca su Aggiungi
								</div>
								<v-checkbox
										v-model="toEditCliccatore.disattivaProvaGratuita"
										label="Disattiva utente"
								></v-checkbox>
							</template>
						</v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="scdColor" rounded depressed style="color:white; text-transform:none;" class="px-6" @click="isCliccatoreDialogOpen = false" :disabled="isLoadingEditCliccatore">Annulla</v-btn>
          <v-btn :color="scdOrange" rounded depressed style="color:white; text-transform:none;" class="px-6" :loading="isLoadingEditCliccatore" @click="isNewCliccatore ? addCliccatore() : editCliccatore()">
            {{ isNewCliccatore ? 'Aggiungi' : 'Salva' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isTeamDialogOpen" max-width="900" persistent>
      <v-card class="pa-6">
        <v-card-title class="headline">
          <span v-if="isNewTeam">Aggiungi Squadra</span>
          <span v-else>Squadra: {{teamSelezionato.nome}}</span>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isTeamDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="teamForm" v-model="validTeamForm" lazy-validation>
            <v-col class="px-5">
              <v-row>
                <v-col>
                    <v-text-field v-model="toEditTeam.nome" label="Scegli il nome della Squadra *" :rules="[vincoli.required, vincoli.teamName]"></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    v-model="toEditTeam.teamleader_id"
                    :items="isNewTeam ? cliccatoriWithoutLeaderTeam0 : cliccatoriWithoutLeader"
                    item-value="id"
                    item-text="username"
                    label="Scegli il Coordinatore (opzionale)"
                    no-data-text="Nessun Coordinatore selezionabile"
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <span class="primary--text" v-if="isNewTeam">
                  <b>Nota: puoi assegnare come Coordinatore solo cliccatori che sono in Senza Squadra</b>
                </span>
                <span class="primary--text" v-else>
                  <b>Nota: puoi assegnare come Coordinatore solo cliccatori che appartengono a questa Squadra</b>
                </span>
              </v-row>
              <v-row>
                <!-- <span class="red--text" v-if="(isNewTeam && computedSimulazioniOggiTeamLeaderSelezionato > 0)">
                  <b>Attenzione: non puoi assegnare un Coordinatore che ha effettuato simulazioni oggi</b>
                </span> -->
                <span class="primary--text" v-if="isNewTeam">
                  <b>Nota: il Coordinatore verrà spostato all'interno della nuova squadra</b>
                </span>
              </v-row>
              <!-- <v-row class="mt-4" justify="space-between">
                <v-col class="pl-0">
                  <span class="body-2 black--text mr-1"><b>Scegli il numero massimo di Cliccatori per la Squadra:</b></span>
                  <v-text-field class="my-2" outlined hide-details v-model="toEditTeam.max_cliccatori" :rules="vincoliTeamCliccatori"></v-text-field>
                  <v-progress-circular v-if="isLoadingGetInfoTeam0" size="18" width="2" indeterminate :color="scdColor"></v-progress-circular>
                  <span v-if="!isLoadingGetInfoTeam0" class="body-2 error--text"><b>(Assegnabili da {{(this.isNewTeam ? (this.toEditTeam.teamleader_id != null ? 1 : 0) : this.cliccatori.length)}} a {{maxCliccatoriTeamField}} cliccatori)</b></span>
                </v-col>
                <v-col class="pr-0">
                  <span class="body-2 black--text mr-1"><b>Scegli il limite di Simulazioni giornaliere per tutta la Squadra:</b></span>
                  <v-text-field class="my-2" outlined hide-details v-model="toEditTeam.max_simulazioni_giorno" :rules="vincoliTeamSimulazioni"></v-text-field>
                  <v-progress-circular v-if="isLoadingGetInfoTeam0" size="18" width="2" indeterminate :color="scdColor"></v-progress-circular>
                  <span v-if="!isLoadingGetInfoTeam0" class="body-2 error--text"><b>(Assegnabili da {{(isNewTeam ? 0 : (teamSelezionato.max_simulazioni_giorno - (simulazioniAssegnabili - simulazioniNonDisponibiliOggi)))}} a {{maxSimulazioniTeamField}} simulazioni)</b></span>
                </v-col>
              </v-row> -->
            </v-col>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn depressed rounded :color="scdColor" style="color:white; text-transform:none;" class="px-6" @click="isTeamDialogOpen = false" :disabled="isLoadingEditTeam">Annulla</v-btn>

          <v-btn :color="scdOrange" class="white--text px-6" :loading="isLoadingEditTeam"
            depressed rounded
            style="color:white; text-transform:none;"
            @click="isNewTeam ? addTeam() : editTeam()"
            :disabled="isLoadingGetInfoTeam0"
          >{{ isNewTeam ? 'Aggiungi' : 'Salva' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSquadraStatsDialogOpen" max-width="1600">
      <v-card style="background-color:#eeeeee">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isSquadraStatsDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <statistiche-squadre-component v-if="isSquadraStatsDialogOpen" :idSquadra="idSquadraToShowStats" :hideGuide="true"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed rounded :color="scdColor" class="mr-4 mb-3 white--text px-6" @click="isSquadraStatsDialogOpen = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isCliccatoreStatsDialogOpen" max-width="1600">
      <v-card style="background-color:#eeeeee">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isCliccatoreStatsDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <statistiche-cliccatore-component v-if="isCliccatoreStatsDialogOpen" :idCliccatore="idCliccatoreToShowStats" :hideGuide="true"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed rounded :color="scdColor" class="mr-4 mb-3 white--text px-6" @click="isCliccatoreStatsDialogOpen = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isCliccatoreGamingDialogOpen" max-width="1600" scrollable>
      <v-card style="background-color:#eeeeee">
        <v-card-title class="headline">
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isCliccatoreGamingDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
					<v-tabs
						v-if="isCliccatoreGamingDialogOpen"
						fixed-tabs
						style="background-color: #eee"
					>
						<v-tab>
							<span class="font-weight-bold">Dashboard</span>
						</v-tab>
						<v-tab v-if="amIAdminOrTeamleader">
							<span class="font-weight-bold">Click Day</span>
						</v-tab>
						<v-tab>
							<span class="font-weight-bold">Game Day</span>
						</v-tab>
						<v-tab>
							<span class="font-weight-bold">Classifica</span>
						</v-tab>

						<v-tab-item>
							<dashboard-gaming-component
								class="pt-6"
								:idCliccatore="idCliccatoreToShowGaming"
							></dashboard-gaming-component>
						</v-tab-item>
						<!--v-if="amIAdminOrTeamleader"-->
						<v-tab-item>
							<click-day-component
								class="pt-6"
								:idCliccatore="idCliccatoreToShowGaming"
							></click-day-component>
						</v-tab-item>
						<v-tab-item>
							<game-day-component
								class="pt-6"
								:idCliccatore="idCliccatoreToShowGaming"
							></game-day-component>
						</v-tab-item>
						<v-tab-item>
							<classifica-gaming-component
								class="pt-6"
								:idCliccatore="idCliccatoreToShowGaming"
							></classifica-gaming-component>
						</v-tab-item>
					</v-tabs>
          <!--<root-gaming-component v-if="isCliccatoreGamingDialogOpen" :idCliccatore="idCliccatoreToShowGaming"/>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed rounded :color="scdColor" class="mr-4 mb-3 white--text px-6" @click="isCliccatoreGamingDialogOpen = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer width="500" right temporary absolute v-model="sidebarDatiCliccatoreVisibile">
      <dati-cliccatore-component v-if="sidebarDatiCliccatoreVisibile" :IdUtenteProp="idCliccatoreToShowDati"></dati-cliccatore-component>
    </v-navigation-drawer>

    <!-- <div v-if="isDatiCliccatoreDialogOpen" style="background-color: rgb(33, 33, 33, 0.46); border-color: rgb(33, 33, 33, 0.46); z-index:9999; position:absolute; top:0; bottom:0; left:0; right:0; width: 100%; height: 100%;">
      <div style="position:absolute; top:50%; left:50%; backgrond-color:white; transform: translate(-50%, -50%); width:500px; height: 80%; overflow:auto;">
        <v-card>
          <v-card-title class="headline">
            <span class="ml-4">Dati cliccatore</span>
            <v-spacer></v-spacer>
            <v-btn color="black--text" icon @click="isDatiCliccatoreDialogOpen = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :idCliccatore="idCliccatoreToShowDati"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="scdColor" class="mr-4 mb-3 white--text" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div> -->

    <v-dialog
	    v-model="isDatiCliccatoreDialogOpen"
	    width="700"
	    scrollable
	    persistent
    >
      <v-card>
        <v-card-title class="headline">
          <!-- <span class="ml-4">DATI CLICCATORE</span> -->
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn color="black&#45;&#45;text" icon @click="isDatiCliccatoreDialogOpen = false">-->
          <!--  <v-icon>close</v-icon>-->
          <!--</v-btn>-->
        </v-card-title>
        <v-card-text>
          <dati-cliccatore-component
	          v-if="isDatiCliccatoreDialogOpen"
	          :IdUtenteProp="idCliccatoreToShowDati"
	          @ci-sono-modifiche-pendenti="bottoneChiudiDatiCliccatoreDisabilitato = $event"
          ></dati-cliccatore-component>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
	          :color="scdColor"
	          class="mr-4 mb-3 white--text"
	          rounded
	          @click="isDatiCliccatoreDialogOpen = false"
	          :disabled="bottoneChiudiDatiCliccatoreDisabilitato"
          >
	          Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<v-dialog v-model="filtriDialog" width="700">
      <v-card>
        <v-card-title>
           <span class="primary--text">Filtri</span>
        </v-card-title>
        <v-card-text>
					<v-select
						v-model="gamedaysIdsSelezionati"
						:items="gamedays"
						item-text="nome_e_data_ora"
						item-value="id"
						label="Game Days"
						:menu-props="{ maxHeight: '400' }"
						:loading="isLoadingGamedaysPerFiltri"
						:disabled="isLoadingGamedaysPerFiltri"
						multiple
						outlined
						dense
						chips
						clearable
						deletable-chips
						class="mr-5"
					></v-select>

					<v-select
						v-if="teamSelezionato.id == -1"
						v-model="teamsIdsSelezionati"
						:items="teamsSenzaTutteLeSquadreComputed"
						item-text="nome"
						item-value="id"
						label="Squadre"
						:menu-props="{ maxHeight: '400' }"
						multiple
						outlined
						dense
						clearable
						deletable-chips
						class="mr-5"
					>

						<template v-slot:selection="{  item, index  }">
							<span v-if="index===0 && teamsIdsSelezionati.length > 0">
								{{ teamsIdsSelezionati.length }} {{ teamsIdsSelezionati.length === 1 ? 'Squadra' : 'Squadre' }} selezionate
							</span>
						</template>
					</v-select>

	        <v-switch
		        v-model="onlyActiveUsers"
		        label="Mostra solo i cliccatori attivi"
		        inset
		        :color="scdOrange"
	        ></v-switch>
	        <v-switch
		        v-model="onlyWhoPassedTheSelection"
		        label="Mostra solo i cliccatori che hanno superato la selezione"
		        inset
		        :color="scdOrange"
	        ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--<v-btn-->
					<!--	rounded-->
					<!--	depressed-->
					<!--	style="text-transform:none; letter-spacing:0.5px;"-->
					<!--	:color="scdColor"-->
					<!--	class="white&#45;&#45;text"-->
					<!--	@click="filtriDialog = false"-->
					<!--&gt;-->
					<!--	Chiudi-->
					<!--</v-btn>-->
	        <v-btn
		        rounded
		        depressed
		        style="text-transform:none; letter-spacing:0.5px;"
		        :color="scdOrange"
		        class="white--text"
		        @click="applicaFiltri()"
	        >
		        Filtra
	        </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	  
	  <v-dialog v-model="limiteCliccatoriAttiviRaggiuntoDialog" width="575">
		  <v-card>
			  <v-card-title>
				  Hai raggiunto il limite massimo di cliccatori attivi.<br>
				  Disabilita un cliccatore o una squadra esistenti per liberare uno slot cliccatore.
			  </v-card-title>
			  <v-card-text class="d-flex">
			  </v-card-text>
			  <v-card-actions>
				  <v-spacer></v-spacer>
				  <v-btn
				  	rounded
				  	depressed
				  	style="text-transform:none; letter-spacing:0.5px;"
				  	:color="scdColor"
				  	class="white--text px-2"
				  	@click="limiteCliccatoriAttiviRaggiuntoDialog = false"
				  >
				  	Chiudi
				  </v-btn>
			  </v-card-actions>
		  </v-card>
	  </v-dialog>
	  
	  <v-dialog v-model="gestioneIscrizioneInMassaAlClickdayDialog" width="575">
		  <v-card>
			  <v-card-title>
				  Iscrizione al Click Day
			  </v-card-title>
			  <v-card-text>
				  <v-radio-group
					  row
					  v-model="opzioneSelezionataPerGestioneIscrizioneInMassaAlClickday"
					  class="mt-1"
				  >
					  <v-radio
						  key="0"
						  value="iscrivi"
						  class="mb-2"
						  color="success"
					  >
						  <template v-slot:label>
							  <span
								  class="ml-1 font-weight-medium"
								  :style="`color: ${$vuetify.theme.currentTheme.success}`"
							  >
								  Iscrivi al Click Day tutti i cliccatori presenti in tabella
							  </span>
						  </template>
					  </v-radio>
					  <v-radio
						  key="1"
						  value="disiscrivi"
						  color="error"
					  >
						  <template v-slot:label>
							  <span
								  class="ml-1 font-weight-medium"
								  :style="`color: ${$vuetify.theme.currentTheme.error}`"
							  >
								  Disiscrivi al Click Day tutti i cliccatori presenti in tabella
							  </span>
						  </template>
					  </v-radio>
				  </v-radio-group>
				  
				  <div
					  v-if="opzioneSelezionataPerGestioneIscrizioneInMassaAlClickday == 'disiscrivi'"
					  class="white--text"
				  >
					  <div>Verranno disiscritti solo i cliccatori che soddisfano TUTTI questi requisiti:</div>
					  <ol>
						  <li>Hanno come "Esito Click Day": Iscritto</li>
						  <li>Non hanno un "Tempo Click Day"</li>
						  <li>Non hanno un "Compenso personalizzato esiti provvisori"</li>
						  <li>Non hanno un "Compenso personalizzato esiti definitivi"</li>
						  <li>Non hanno delle "Note compenso"</li>
						  <li>Non hanno inserito i dati di fatturazione</li>
					  </ol>
				  </div>
			  </v-card-text>
			  <v-card-actions>
				  <v-spacer></v-spacer>
				  <v-btn
				  	rounded
				  	depressed
				  	style="text-transform:none; letter-spacing:0.5px;"
				  	:color="scdColor"
				  	class="white--text px-2"
				  	@click="gestioneIscrizioneInMassaAlClickdayDialog = false"
					  :disabled="isLoadingIscriviDisiscriviInMassa"
				  >
				  	Chiudi
				  </v-btn>
				  <v-btn
					  rounded
					  depressed
					  style="text-transform:none; letter-spacing:0.5px;"
					  :color="scdOrange"
					  class="white--text"
					  @click="iscriviDisiscriviInMassa()"
					  :loading="isLoadingIscriviDisiscriviInMassa"
				  >
					  OK
				  </v-btn>
			  </v-card-actions>
		  </v-card>
	  </v-dialog>

    <v-snackbar
        v-model="showSnackbar"
        bottom
        :timeout="5000"
        v-if="alertType != null && message != null"
        :color="(alertType == 'warning' ? 'warning' : (alertType != 'error' ? scdColor : 'error'))"
    >
      <span v-html="message"></span>
      <v-btn color="white" text @click="alertType = null">
        Chiudi
      </v-btn>
    </v-snackbar>

    <v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions"></v-tour>
  </v-container>
</template>

<script>
import mixin from '../mixins';
import store from '../store';

import { GeneratePassword } from "js-generate-password";

export default {
  data() {
    return {
	    testSwitch: false,
      showSnackbar: false,
      alertType: null,
      message: null,

			isRicercaMatchEsattoAbilitato: false,

			bandoConSimulazioni: false,

      isLoadingCliccatori: false,
      searchCliccatore: null,

			dialogVisibilitaColonne: false,

			teamsIdsSelezionati: [],

      // filtrato in computedHeadersCliccatori
      headersCliccatori: [
				{
					text: "Squadra", // Questa colonna sarà disponibile solo con teamSelezionato.id == -1 (cioè per 'Tutti i cliccatori')
					value: "team.nome", 
					isVisibile: true 
				},
        {
					text: "Cliccatore",
					value: "username",
					// width: "100px"
					isVisibile: true, // Inserito per mostrare o nascondere la colonna dinamicamente
				},
        {
					text: "Email",
					value: "email",
					isVisibile: true,
				},
				{
					text: "Codice cliccatore",
					value: "codice_cliccatore",
					isVisibile: true,
				},
	      {
		      text: "Nome",
		      value: "nome",
					isVisibile: true,
	      },
	      {
		      text: "Cognome",
		      value: "cognome",
					isVisibile: true,
	      },
	      {
		      text: "Cellulare",
		      value: "cellulare",
					isVisibile: false,
	      },
        {
					text: "Simulazioni totali",
					value: "simulazioni_totali",
					isVisibile: true,
					// filterable: false,
					// width: "100px"
				},
        {
					text: "Vinte tra le ultime", // In seguito verrà aggiunto il numero delle ultime: Es. Vinte tra le ultime 100
					value: "vincenti_ultime_x",
					isVisibile: true,
					// filterable: false,
					// width: "94px"
				},
        {
					text: "Perse tra le ultime",
					value: "perdenti_ultime_x",
					isVisibile: true,
					// filterable: false,
					// width: "94px"
				},
        {
					text: "Percentuale simulazioni abbandonate su ultime",
					value: "abbandonate_perc_ultime_x",
					isVisibile: true,
					// filterable: false,
					// width: "115px"
				},
        {
					text: "Tempo medio tra le ultime",
					value: "tempo_medio_ultime_x",
					isVisibile: true,
					// filterable: false,
					// width: "118px"
				},
				{
					text: "Win score attuale",
					value: "win_score_attuale_o_vincenti_perc_ultime_x",
					isVisibile: true,
					// filterable: false,
					width: "50px"
				},
        {
					text: "Win score migliore",
					value: "win_score",
					isVisibile: true,
					// filterable: false,
					width: "50px"
				},
				{
					text: "Data superamento selezione", // Visibile solo al cliente ClickDay.it
					value: "dataora_superamento_selezione",
					isVisibile: true,
					// filterable: false,
					width: "50px"
				},
        // { text: "Tempo medio", value: "tempo_medio", filterable: false },
				{
					text: "Classifica",
					value: "posizione_classifica",
					isVisibile: true,
					align: "center",
					// sortable: false,
				},
				{
					text: "Ultimo accesso",
					value: "ultimo_accesso",
					isVisibile: true,
					align: "center",
					// sortable: false,
				},
        {
					text: "Stato",
					value: "stato",
					isVisibile: true,
					// filterable: false,
					align: "center",
					// width: "75px"
					sortable: false,
				},
        {
					text: "Azioni",
					value: "actions",
					isVisibile: true,
					sortable: false,
					// filterable: false,
					align: "center",
					width: '230px'
				},
      ],
      cliccatori: [],
      cliccatoriSortDesc: [/*'true'*/],
      cliccatoriSortBy: [/*'vincenti_ultime_x'*/], // Ordinamento di default spostato nel Backend

      // ----------------- Tour guidato al primo accesso: ------------------
      tourSteps: [],
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Salta guida',
          buttonPrevious: 'Precedente',
          buttonNext: 'Successivo',
          buttonStop: 'Fine'
        }
      },
      // -------------------------------------------------------------------

      // Aggiunta/modifica cliccatore:
      showPasswordInput: false,
      isCliccatoreDialogOpen: false,
      isNewCliccatore: true,
      teamleaders: [{ id: null, username: "Nessuno" }],
      toEditCliccatore: {
        id: null,
        username: null,
        email: null,
        cellulare: null,
	      nome: null,
	      cognome: null,
        ruolo: null,
        passwordNC: null,
        team_id: 0,
				codice_cliccatore: null,
        disattivaProvaGratuita: false
      },
      isLoadingEditCliccatore: false,
      isProvaGratuita: false,

      // ############ Selezione e amministrazione Team: ##############
      indexTeamSelezionato: null, // Indice del team (dell'array teams[])
      teamSelezionato: {},
      teams: [],

      isLoadingTeams: false,

      isTeamDialogOpen: false,
      isNewTeam: true,
      toEditTeam: {
        id: null,
        nome: null,
        teamleader_id: null
      },

      salvataggioAttivaDisattivaSquadra: false,
      // #############################################################

      cliccatoriTeam0: [], // Utilizzate in fase di creazione di un nuovo Team

      isLoadingGetInfoTeam0: false,

      isLoadingEditTeam: false,

      validTeamForm: false,

      validCliccatoreForm: false,

      // ########## STATS DEL SINGOLO CLICCATORE ############
      isCliccatoreStatsDialogOpen: false,
      idCliccatoreToShowStats: null,
      // ####################################################

      isSquadraStatsDialogOpen: false,
      idSquadraToShowStats: null,

      // GAMING CLICKDAY.IT =============
      isCliccatoreGamingDialogOpen: false,
      idCliccatoreToShowGaming: null,
      // ================================

      // Dati cliccatore
      sidebarDatiCliccatoreVisibile: false,
      isDatiCliccatoreDialogOpen: false,
      idCliccatoreToShowDati: null,
	    
	    // filtri
			
			numFiltriAttivi: 0,
	    filtriDialog: false,
			isLoadingGamedaysPerFiltri: false,
			gamedays: [],
			gamedaysIdsSelezionati: [],
			gamedaysIdsApplicati: [],
	    onlyActiveUsers: false,
	    onlyActiveUsersEnabled: false,
	    onlyWhoPassedTheSelection: false,
	    onlyWhoPassedTheSelectionEnabled: false,
	    
	    isLoadingAttivaDisattivaSquadra: false,
	    isLoadingAttivaDisattivaCliccatore: false,
	    
	    isLoadingInfoCliccatoriAttivi: false,
	    infoCliccatoriAttivi: {
				attivi: null,
		    max_cliccatori_disponibili: null
	    },
	    limiteCliccatoriAttiviRaggiuntoDialog: false,
	    
	    mostraNavigationDrawer: true,
	    
	    bottoneChiudiDatiCliccatoreDisabilitato: false,
	    
	    gestioneIscrizioneInMassaAlClickdayDialog: false,
	    opzioneSelezionataPerGestioneIscrizioneInMassaAlClickday: null,
	    isLoadingIscriviDisiscriviInMassa: false,
			
			isLoadingIscrizione: false,

			minimoSimulazioniSelezione: 0, // Numero di simulazioni necessarie per poter superare o meno la selezione
    };
  },

  created: function() {
	  this.getInfoCliccatoriAttivi();
    this.getTeams();
    this.ifGamingAbilitato();
  },

  watch: {
    indexTeamSelezionato: function(newIndex, oldIndex) {
			if(newIndex === null || newIndex === "" || newIndex === undefined){
        // Ho deselezionato la squadra (è possibile ri-cliccando sulla voce di menù) => La riseleziono
        this.teamSelezionato = this.teams[oldIndex];

				if(this.teamSelezionato.id !== -1)
					this.teamsIdsSelezionati = [];
				else
					this.teamsIdsSelezionati = this.getIdsTeams(true);

        return;
      }

			this.teamSelezionato = this.teams[newIndex];

			if(this.teamSelezionato.id !== -1)
				this.teamsIdsSelezionati = []; // Svuoto i teams selezionati
			else
				this.teamsIdsSelezionati = this.getIdsTeams(true); // Reinserisco la selezione di default (= Tutti)

      this.searchCliccatore = null;

      this.alertType = null;
      this.message = null;

      // this.indexCliccatoreLimiteToEdit = null;

      this.cliccatori.splice(0, this.cliccatori.length);
      this.getCliccatori();
    },
    isTeamDialogOpen: function(isOpen) {
      if (isOpen) {
        if(this.$refs.teamForm != undefined) this.$refs.teamForm.resetValidation();
        this.alertType = null;
        this.message = null;

        this.getInfoTeam0();
      }
    },
    alertType: function(newVal){
      if(newVal != null){
        // Mostra la Snackbar quando c'è un messaggio di successo/errore
        this.showSnackbar = true;
      }
    },
  },

  computed: {
		teamsSenzaTutteLeSquadreComputed: function(){
			// Restituisce i teams senza la voce 'Tutti i cliccatori'
			return this.teams.slice(1);
		},
    cliccatoriWithoutLeader: function() {
      return this.cliccatori.filter(cliccatore => {
          return cliccatore.ruolo != "Admin";
      });
    },
    cliccatoriWithoutLeaderTeam0: function() {
      return this.cliccatoriTeam0.filter(cliccatore => {
          return cliccatore.ruolo != "Admin";
      });
    },

		// Nota: spostato il caricamento dei soli cliccatori delle squadre selezionate nel Backend per uniformare con gli altri filtri
		// cliccatoriBySquadreVisibiliComputed: function(){
		// 	console.log(this.teamSelezionato)
		// 	console.log(this.teamsIdsSelezionati)

		// 	// Utilizzato nella sezione 'Tutti i cliccatori' in cui è possibile selezionare i team da mostrare/nascondere come Filtro
		// 	if(this.teamSelezionato.id != -1)
		// 		return this.cliccatori;

		// 	return this.cliccatori.filter(cliccatore => this.teamsIdsSelezionati.includes(cliccatore.team_id))
		// },
		
		// Nota: questo computed restituisce gli headers filtrati dal tipo di bando/cliente/ecc..
		// 		Invece il computed computedHeadersVisibiliCliccatori(..) mostra solo le colonne al momento visibili
		//		La funzione checkHeaderIsVisibile(..) nasconderà gli slot interni a v-data-table in base alla presenza o meno delle colonne tra le visibili
		computedHeadersCliccatori: function() { 
			// Creo una copia dell'headers da manipolare:
			let headersCliccatoriCustom = JSON.parse(JSON.stringify(this.headersCliccatori));

			// Se l'id del team selezionato è != -1 (cioè Tutti i cliccatori) allora rimuovo la colonna 'Squadra' (la prima):
			if(this.teamSelezionato.id != -1){
				headersCliccatoriCustom.shift();
				// headersCliccatoriCustom.unshift( // Sempre visibile
				// 	{ text: "Squadra", value: "team.nome", isVisibile: true }
				// );
			}
			
      if (this.bandoConSimulazioni && this.computedClienteClickdayIt) { // cliente clickday
				const colonneNascoste = ['email'];
				return headersCliccatoriCustom.filter(header => !colonneNascoste.includes(header.value));
      }
      else if (this.bandoConSimulazioni) { // tutti gli altri clienti - bando con simulazioni
				const colonneNascoste = ['email', 'win_score_attuale_o_vincenti_perc_ultime_x', 'win_score', 'dataora_superamento_selezione', 'posizione_classifica', 'ultimo_accesso'];
				return headersCliccatoriCustom.filter(header => !colonneNascoste.includes(header.value));
      }
      else { // tutti i clienti - bando senza simulazioni
				const colonneVisibili = ['username', 'posizione_classifica', 'stato', 'actions'];
				return headersCliccatoriCustom.filter(header => colonneVisibili.includes(header.value));
      }
      // return this.headersCliccatori.filter(header => header.value != "email")

      // if (this.gamingAbilitato) {
      //   return headersCliccatoriCustom.filter(header => header.value != "miglior_punteggio")
      // } else {
      //   return headersCliccatoriCustom
      // }
    },

		computedHeadersVisibiliCliccatori: function(){
			return this.computedHeadersCliccatori.filter(header => header.isVisibile)
		},
	},

  methods: {

		ricercaPersonalizzataTabella: function(value, search, item){
			if (!search) return true; // Nessun filtro se non c'è input di ricerca

      // Se exactMatch è attivo, confronta esattamente
      if (this.isRicercaMatchEsattoAbilitato) {
        return value === search;
      }

      // Altrimenti, applica un filtro che non richiede corrispondenza esatta
      return value?.toString().toLowerCase().includes(search.toLowerCase());
		},

		modificaVisibilitaColonna: function(valueColonna, isVisibile){
			this.headersCliccatori.some((header)=>{
				if(header.value.toLowerCase() == valueColonna.toLowerCase()){
					header.isVisibile = isVisibile;
					return true;
				}
			})
		},
		checkHeaderIsVisibile(value){
			let trovato = false;
			this.computedHeadersVisibiliCliccatori.some(header => {
				if(header.value.toLowerCase() == value.toLowerCase()){
					trovato = true;
					return true;
				}
			});

			return trovato;
		},

		getIdsTeams: function(eccettoTutteLeSquadre = false){
			let ids = [];
			this.teams.forEach(team => {
				if (!(eccettoTutteLeSquadre && team.id === -1)) {
					ids.push(team.id);
				}
			});
			
			return ids;
		},

    getTeams: function(indexTeamSelezionato) {
      this.alertType = null;
      this.message = null;

      this.isLoadingTeams = true;

      axios
        .get("/teams")
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
						let teamsDaOrdinare = response.data.data;

						// Riordino i teams in questo modo:
						// - se cliente clickdayit allora Tutti i cliccatori -> Senza squadra -> Riserve -> ..altre squadre ordinate alfabeticamente
						// - altri clienti allora Tutti i cliccatori -> Senza squadra ->...squadre ordinate alfabeticamente
						// let tuttiICliccatori = teamsDaOrdinare[0];
						// teamsDaOrdinare = teamsDaOrdinare.slice(1); // Elimino Tutti i cliccatori
						teamsDaOrdinare.sort((a, b) => {
							if(a.nome.toLowerCase() == 'tutti i cliccatori')
								return -1;
							if(b.nome.toLowerCase() == 'tutti i cliccatori')
								return 1;

							if(a.nome.toLowerCase() == 'senza squadra' && b.nome.toLowerCase() != 'tutti i cliccatori')
								return -1;
							if(b.nome.toLowerCase() == 'senza squadra' && a.nome.toLowerCase() != 'tutti i cliccatori')
								return 1;

							if(this.computedClienteClickdayIt){
								if(a.nome.toLowerCase() == 'riserve' && b.nome.toLowerCase() != 'tutti i cliccatori' && b.nome.toLowerCase() != 'senza squadra'){
									return -1;
								}
								if(b.nome.toLowerCase() == 'riserve' && a.nome.toLowerCase() != 'tutti i cliccatori' && a.nome.toLowerCase() != 'senza squadra'){
									return 1;
								}
							}

							return a.nome.localeCompare(b.nome)
						}); // Ordino tutti in maniera alfabetica (localeCompare ignora gli accenti, ecc)
						// teamsDaOrdinare.unshift(tuttiICliccatori); // Rimetto tutti i cliccatori a inizio array

						// Se sono cliente clickdayit, inverto quindi Riserve e Senza squadre:
						// if(this.computedClienteClickdayIt){
						// 	// Controllo per sicurezza:
						// 	if(teamsDaOrdinare[1].nome.toLowerCase() == 'riserve' && teamsDaOrdinare[2].nome.toLowerCase() == 'senza squadra'){
						// 		let riserveTmp = teamsDaOrdinare[1];
						// 		teamsDaOrdinare[1] = teamsDaOrdinare[2];
						// 		teamsDaOrdinare[2] = riserveTmp;
						// 	}
						// }

						this.teams = teamsDaOrdinare;

						// Di default la sezione "Tutti i cliccatori" mostra tutte le squadre, quindi inserisco gli id:
						this.teamsIdsSelezionati = this.getIdsTeams(true);
						
            if (indexTeamSelezionato) { // quando chiamo questa funzione dopo aver modificato un cliccatore
              this.indexTeamSelezionato = indexTeamSelezionato;
              this.teamSelezionato = this.teams[indexTeamSelezionato];
            } else { // quando carico la pagina e chiamo questa funzione nel created
              this.indexTeamSelezionato = 0;
              this.teamSelezionato = this.teams[0];
            }

          }

        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nel caricamento della Squadra";
        })
        .finally(() => {
          this.isLoadingTeams = false;
        });
    },
    getCliccatori: function() {
      // Se li lascio, quando chiamo editTeam (che chiama getCliccatori()) dato che vanno a NULL, non viene mostrato lo SnackBar
      // this.alertType = null;
      // this.message = null;

      this.isLoadingCliccatori = true;

      let idTeam = this.teamSelezionato.id;

			let myTeamsIdsSelezionati = null;
			if(this.teamsIdsSelezionati)
				myTeamsIdsSelezionati = this.teamsIdsSelezionati;

      axios.post("/team/" + idTeam.toString() + "/cliccatori", {
				gamedays_ids: this.gamedaysIdsSelezionati,
				teams_ids: myTeamsIdsSelezionati,
	      only_active_users: this.onlyActiveUsers,
	      only_who_passed_the_selection: this.onlyWhoPassedTheSelection
			})
        .then(response => {
					if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {

						this.bandoConSimulazioni = response.data.bando_con_simulazioni;
						this.minimoSimulazioniSelezione = response.data.minimo_simulazioni_selezione;
						this.cliccatori = response.data.cliccatori;
	          
            this.cliccatori.forEach(cliccatore => {
              // Il seguente valore lo calcolo inizialmente, e poi ogni volta che aggiungo/modifico i limiti dei cliccatori
              // cliccatore.computed_simulazioni_disponibili_oggi = cliccatore.max_simulazioni_giorno - cliccatore.simulazioni_non_disponibili_oggi

              // setto i null come -1 in modo che ordinando in modo descendente in tabella i null si posizioneranno sotto gli 0
              if (cliccatore.miglior_punteggio === null) {
                cliccatore.miglior_punteggio = -1
              }

              // Se idTeam è 0 i dati lo avranno a NULL (da DB), quindi imposto 0 anche qui:
              if(idTeam == 0) cliccatore.team_id = 0;
            });

						this.gamedaysIdsApplicati = Object.assign([], this.gamedaysIdsSelezionati);
						this.onlyActiveUsersEnabled = JSON.parse(JSON.stringify(this.onlyActiveUsers));
						this.onlyWhoPassedTheSelectionEnabled = JSON.parse(JSON.stringify(this.onlyWhoPassedTheSelection));

            // this.ricalcolaContatoriSimulazioniDisponibili();
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nel caricamento dei cliccatori. Riprova.";
        })
        .finally(() => {
          this.isLoadingCliccatori = false;
        });
    },
    numeroLivello: function(migliorPunteggio) {
      const data = this.getLivello(migliorPunteggio);
      return data.livello;
    },
    getIndexCliccatoreFromID: function(idCliccatore){
      let index = null;
      this.cliccatori.some(function(el, idx){
        if(el.id == idCliccatore){
          index = idx;
          return true;
        }
      })

      return index;
    },
    getInfoTeam0() {
      this.alertType = null;
      this.message = null;

      this.isLoadingGetInfoTeam0 = true;

      axios
        .get("/team/0/info")
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            // this.simulazioniAssegnabiliOggiTeam0 = parseInt(response.data.data.simulazioniDisponibili);
            // this.cliccatoriDisponibiliTeam0 = parseInt(response.data.data.cliccatoriDisponibili);

            // Mi servono i cliccatori del Team 0 per poter creare i nuovi Team (i cui teamLeader sono una scelta del Team0)
            this.cliccatoriTeam0 = response.data.data.cliccatori;
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message =
            "Errore nel caricamento delle Squadre. Riprova";
        })
        .finally(() => {
          this.isLoadingGetInfoTeam0 = false;
        });
    },
    resetCliccatoreToEdit: function() {
      this.toEditCliccatore = {
        username: null,
        email: null,
				cellulare: null,
	      nome: null,
	      cognome: null,
        ruolo: null,
        passwordNC: null,
        team_id: 0,
				codice_cliccatore: null,
        disattivaProvaGratuita: false
      };
    },
    openEditCliccatoreDialog: function(isNew = true, cliccatore = null) {
			if (this.infoCliccatoriAttivi.attivi >= this.infoCliccatoriAttivi.max_cliccatori_disponibili && isNew) {
				this.limiteCliccatoriAttiviRaggiuntoDialog = true;
				return;
			}
			
      this.showPasswordInput = false; // Di default non mostrare la password

      if (isNew) {
        this.resetCliccatoreToEdit();
        this.toEditCliccatore.team_id = this.teamSelezionato.id; // Di default il team in cui mi trovo
        this.isNewCliccatore = true;
      } else {
        this.toEditCliccatore = Object.assign({}, cliccatore);
	      this.$set(this.toEditCliccatore, "passwordNC", null); // reactive
        this.isNewCliccatore = false;
      }
	    
      // Azzero la Validazione
      if(this.$refs.cliccatoreForm != undefined) this.$refs.cliccatoreForm.resetValidation();

      this.isCliccatoreDialogOpen = true;
    },
    addCliccatore: function() {
      this.alertType = null;
      this.message = null;

      if (!this.$refs.cliccatoreForm.validate()) {
        return;
      }

      this.isLoadingEditCliccatore = true;

      axios.post("/cliccatori", this.toEditCliccatore)
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
            this.isProvaGratuita = response.data.isProvaGratuita;
          } else {
            let newCliccatore = response.data.data;
            // Il seguente valore lo calcolo inizialmente, e poi ogni volta che aggiungo/modifico i limiti dei cliccatori
            // newCliccatore.computed_simulazioni_disponibili_oggi = parseInt(newCliccatore.max_simulazioni_giorno) - parseInt(newCliccatore.simulazioni_non_disponibili_oggi);

            // if (newCliccatore.team_id == null && this.teamSelezionato.id == 0) {
            //   newCliccatore.team_id = 0;
            //   this.cliccatori.push(Object.assign({}, response.data.data));
            // } else if (response.data.data.team_id == this.teamSelezionato.id) {
            //   this.cliccatori.push(Object.assign({}, response.data.data));
            // }
			
						this.getCliccatori();

            this.alertType = "success";
            if(this.toEditCliccatore.email != null && this.toEditCliccatore.email != ""){
              this.message = "Cliccatore aggiunto con successo. Abbiamo inviato un'email con le credenziali di accesso.";
            } else {
              this.message = "Cliccatore aggiunto con successo.";
            }

            this.resetCliccatoreToEdit();
            this.getTeams(this.indexTeamSelezionato);

            this.isCliccatoreDialogOpen = false;
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nella creazione del cliccatore. Riprova";
        })
        .finally(() => {
          this.isLoadingEditCliccatore = false;
        });
    },
    editCliccatore: function() {
      this.alertType = null;
      this.message = null;

      if (!this.$refs.cliccatoreForm.validate()) {
        return;
      }

      let cliccatoreOriginaleIndex = null;

      let self = this;
      this.cliccatori.some((cliccatore, index) => {
        if (self.toEditCliccatore.id == cliccatore.id) {
          cliccatoreOriginaleIndex = index;
          return true;
        }
      });

      this.isLoadingEditCliccatore = true;

      axios.patch("/cliccatori/" + this.toEditCliccatore.id, this.toEditCliccatore)
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            if (response.data.data.team_id == null) {
              response.data.data.team_id = 0;
            }

            // Se ho modificato il Team di appartenenza:
            if (this.cliccatori[cliccatoreOriginaleIndex].team_id != parseInt(response.data.data.team_id)) {
              let self = this;

              // Tolgo 1 slot cliccatore dal team di partenza e lo aggiungo al team di destinazione:
              // this.teams.forEach(function(team){
              //   if(team.id == self.cliccatori[cliccatoreOriginaleIndex].team_id){ // Team di partenza
              //     team.max_cliccatori--;
              //   } else if(team.id == parseInt(response.data.data.team_id)) { // Team di destinazione
              //     team.max_cliccatori++;
              //   }
              // });

              // Se era TeamLeader, elimino il riferimento al TeamLeader dal Team selezionato:
              if(this.cliccatori[cliccatoreOriginaleIndex].ruolo == 'Teamleader'){ // Spostato un Teamleader
                this.teamSelezionato.teamleader_id = null; // Se il team ha id = -1 (cioè 'Tutti i cliccatori') allora non cambierà nulla 

                // Metto a NULL anche il valore del Team di partenza (dopo averlo cercato, non avendo il riferimento)
                this.teams.forEach(function(team){
                  if(team.id == self.teamSelezionato.id) team.teamleader_id = null;
                });
              }

              // Ho modificato il Team, elimino dalla tabella e ricalcolo le simulazioni rimanenti:
							// => Fatto solo se la tabella del team attuale è != -1 (Tutti i cliccatori)
							if(this.teamSelezionato.id != -1)
								this.cliccatori.splice(cliccatoreOriginaleIndex, 1);
							else
								this.getCliccatori(); // Prendo nuovamente i cliccatori del team "Tutti i cliccatori"

              this.getTeams(this.indexTeamSelezionato);
              // this.ricalcolaContatoriSimulazioniDisponibili();
            } else { // Il team non è cambiato => riprendo il cliccatore per come arriva dal Server (e gli aggiungo il campo extra)
              // let editedCliccatore = Object.assign({}, response.data.data);
			  //
              // // editedCliccatore.computed_simulazioni_disponibili_oggi = parseInt(editedCliccatore.max_simulazioni_giorno) - parseInt(editedCliccatore.simulazioni_non_disponibili_oggi);
              // this.cliccatori[cliccatoreOriginaleIndex] = editedCliccatore;
			  //
              // // Aggiorno la UI:
              // this.cliccatori = JSON.parse(JSON.stringify(this.cliccatori));
	            
	            this.getCliccatori();
            }
	          
			this.isCliccatoreDialogOpen = false;
            this.resetCliccatoreToEdit();

            this.alertType = "success";
            this.message = "Cliccatore modificato con successo.";
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nella modifica del cliccatore. Riprova";
        })
        .finally(() => {
          this.isLoadingEditCliccatore = false;
        });
    },
    resetTeamToEdit: function() {
      this.toEditTeam = {
        id: null,
        nome: null,
        teamleader_id: null,
        // LI DEVO METTERE QUA?
        // is_active: null,
        // numero_cliccatori: null

      };
    },
    openEditTeamDialog(isNew = true) {
      if(isNew){
        this.resetTeamToEdit();
        this.isNewTeam = true;
      } else {
        this.toEditTeam = Object.assign({}, this.teamSelezionato);
        this.isNewTeam = false;
      }

      // All'apertura del dialog, imposto i vincoli sui campi Cliccatori e Simulazioni:
      // let minCliccatori = ((v) => { return (parseInt(v) >= (this.isNewTeam ? (this.toEditTeam.teamleader_id != null ? 1 : 0) : this.cliccatori.length)) || "Valore troppo piccolo"})
      // let maxCliccatori = ((v) => { return (parseInt(v) <= this.maxCliccatoriTeamField) || "Valore troppo grande"});

      // let minSimulazioni = ((v) => { return (parseInt(v) >= (this.isNewTeam ? 0 : (this.teamSelezionato.max_simulazioni_giorno - (this.simulazioniAssegnabili - this.simulazioniNonDisponibiliOggi)))) || "Valore troppo piccolo" });
      // let maxSimulazioni = ((v) => { return (parseInt(v) <= this.maxSimulazioniTeamField) || "Valore troppo grande"});

      // this.vincoliTeamCliccatori = [this.vincoli.required, this.vincoli.isNumber, minCliccatori, maxCliccatori];
      // this.vincoliTeamSimulazioni = [this.vincoli.required, this.vincoli.isNumber, minSimulazioni, maxSimulazioni];

      this.isTeamDialogOpen = true;
    },
    addTeam: function() {
      this.alertType = null;
      this.message = null;

      if (!this.$refs.teamForm.validate()) {
        return;
      }

      this.isLoadingEditTeam = true;

      axios
        .post("/team", this.toEditTeam)
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            this.teams.push(Object.assign({}, response.data.data));

            this.alertType = "success";
            this.message = "Squadra aggiunta con successo";

            this.resetTeamToEdit();

            // Se sono su teamId = 0, devo eliminare il cliccatore che è diventato teamLeader dall'array dei cliccatori:
            if (this.teamSelezionato.id == 0) {
              let self = this;
              this.cliccatori.some((cliccatore, index) => {
                if (cliccatore.id == response.data.data.teamleader_id) {
                  self.cliccatori.splice(index, 1);
                  return true;
                }
              });

              // Rieseguo i calcoli sul num max di simulazioni:
              // this.ricalcolaContatoriSimulazioniDisponibili();
            }

            this.getTeams(this.indexTeamSelezionato);

          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nella creazione della Squadra. Riprova";
        })
        .finally(() => {
          this.isLoadingEditTeam = false;
          this.isTeamDialogOpen = false;
        });
    },
    editTeam: function() {
      this.alertType = null;
      this.message = null;

      if (!this.$refs.teamForm.validate()) {
        return;
      }

      this.isLoadingEditTeam = true;

      axios
        .patch("/team/"+this.toEditTeam.id.toString(), this.toEditTeam)
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            this.alertType = "success";
            this.message = "Squadra modificata con successo.";
            this.showSnackbar = true; // Forza la visualizzazione della Snackbar perché a volte non si vede (qualcosa rimette a null 'alertType')
            let self = this;

            // Il team potrebbe aver cambiato nome e teamleader_id in tal caso andrebbe modificato col nuovo nome:
            this.teams.some(function(team){
              if(team.id == self.toEditTeam.id){
                team.nome = response.data.data.nome;
                // team.max_cliccatori = response.data.data.max_cliccatori;
                team.teamleader_id = response.data.data.teamleader_id;
                team.team_leader = response.data.data.team_leader;

                // Aggiorno anche il "teamSelezionato":
                self.teamSelezionato = team;
	              
                return true;
              }
            });

            // Aggiorno la UI:
            this.teams = JSON.parse(JSON.stringify(this.teams));

            // Successivamente ricarico i cliccatori del Team
            this.getCliccatori();

            this.resetTeamToEdit();
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nella modifica della Squadra. Riprova";
        })
        .finally(() => {
          this.isLoadingEditTeam = false;
          this.isTeamDialogOpen = false;
        });
    },

    // ######## STATISTICHE CLICCATORE SELEZIONATO #########
    showStatsCliccatore: function(idCliccatore){
      this.idCliccatoreToShowStats = idCliccatore;
      this.isCliccatoreStatsDialogOpen = true;
    },
    showStatsSquadra: function(idSquadra){
      this.idSquadraToShowStats = idSquadra;
      this.isSquadraStatsDialogOpen = true;
    },
    // #####################################################
    showGamingCliccatore: function(idCliccatore){
      this.idCliccatoreToShowGaming = idCliccatore;
      this.isCliccatoreGamingDialogOpen = true;
    },
    ifGamingAbilitato: function() {
      if (this.gamingAbilitato) {
        // this.headersCliccatori.forEach(header => {
        //   if (header.value == 'vincenti_ultime_x') {
        //     header.width = "130px";
        //   }
        // });
        // this.cliccatoriSortDesc = [true];
        // this.cliccatoriSortBy = ['vincenti_ultime_x'];
      }
    },
    showDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.isDatiCliccatoreDialogOpen = true;
    },
    sidebarDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.sidebarDatiCliccatoreVisibile = true;
    },
    // createOverlay(){
    //   const rootElement = document.querySelector('.v-application');
    //   const overlay = document.createElement('div')
    //   overlay.classList.add('v-overlay', 'v-overlay--active', 'theme--dark', '_overlay')
    //   rootElement.appendChild(overlay)
    //   // console.log(element.className);
    // },

		myStopPropagation(event){
			// Funzione di uso generico che serve a interrompere la propagazione (usata per esempio con il pulsante di attivazione/disattivazione
			// squadra che è posto sopra il bottone che se cliccato carica i cliccatori della squadra)
			event.stopPropagation();
		},
    attivaDisattivaSquadra(idSquadra, isActive, team) { // Passato l'intero team per gestire meglio lo switch
			// In particolare lo switch viene modificato subito prima che venga data conferma,
			//		per evitare ciò lo risetto suo al suo valore iniziale, e poi lo ri-modifico dopo la conferma:

			this.$nextTick(() => { // Per essere sicuro che il dialog è stato montato e ha le funzioni disponibili
				team.is_active = !isActive; // Ripristino lo stato precedente al momento:

				store.commit('mostraDialogConferma', 
					{
						titolo: "Abilitazione squadra",
						testo: 'Sei sicuro di voler ' + (isActive ? 'attivare' : 'disattivare') + " la squadra?",
						onConferma:()=>{
							this.isLoadingAttivaDisattivaSquadra = true;
							
							if (!isActive) {
								this.isLoadingCliccatori = true;
							}
							axios.patch('/attivaDisattivaSquadra', {
								idSquadra: idSquadra,
								isActive: isActive
							})
								.then(response => {
									if (response.data.hasError) {
										this.alertType = "error";
										this.message = response.data.messages[0];
									} else {
										team.is_active = isActive
									}
									this.getInfoCliccatoriAttivi();
									if (!isActive) this.getCliccatori();
								})
								.catch(error => {
									this.alertType = "error";
									this.message = "Errore nell'attivazione/disattivazione della squadra";
								})
								.finally(() => {
									this.isLoadingAttivaDisattivaSquadra = false;
								});
							
							store.commit('nascondiDialogConferma');
						}, 
						onAnnulla:()=>{
							store.commit('nascondiDialogConferma');
						}
					}
				)

			});
    },
    attivaDisattivaCliccatore(idCliccatore, isActive) {
	    if (this.infoCliccatoriAttivi.attivi >= this.infoCliccatoriAttivi.max_cliccatori_disponibili && isActive) {
		    this.limiteCliccatoriAttiviRaggiuntoDialog = true;

				setTimeout(() => {
					this.cliccatori.find(cliccatore => cliccatore.id == idCliccatore).is_active = false;
				}, 100)

		    return;
	    }
			
			this.isLoadingAttivaDisattivaCliccatore = true;
      axios
      .patch('/attivaDisattivaCliccatore', {
        idCliccatore: idCliccatore,
        isActive: isActive
      })
      .then(response => {
        if (response.data.hasError) {
          this.alertType = "error";
          this.message = response.data.messages[0];
        }
				
				this.getInfoCliccatoriAttivi();
      })
      .catch(error => {
        this.alertType = "error";
        this.message = "Errore nell'attivazione/disattivazione del cliccatore";
      })
      .finally(() => {
	      this.isLoadingAttivaDisattivaCliccatore = false;
      });
    },
		apriFiltriDialog() {
			this.filtriDialog = true;
			this.getGameDaysPerFiltri();
		},
		getGameDaysPerFiltri() {
			this.isLoadingGamedaysPerFiltri = true;
			axios.get('/cliccatori/gamedays-per-filtri')
				.then(response => {
					this.gamedays = response.data;
					this.isLoadingGamedaysPerFiltri = false;
				})
		},
		applicaFiltri() {
			// Conta quanti filtri sono attivi
			let count = 0;

			if (this.gamedaysIdsSelezionati.length > 0) count++;
			if (this.teamsIdsSelezionati.length > 0) count++;
			if (this.onlyActiveUsers) count++;
			if (this.onlyWhoPassedTheSelection) count++;

			this.numFiltriAttivi = count; // Aggiorna il contatore del badge

			// Chiude il dialog dei filtri e aggiorna la tabella
			this.filtriDialog = false;
			this.getCliccatori();
		},

		resetFiltri() { //annulla tutti i filtri (aggiunta da Nik il 01-02-2025)
	    this.gamedaysIdsSelezionati = [];
	    this.teamsIdsSelezionati = [];
	    this.onlyActiveUsers = false;
	    this.onlyWhoPassedTheSelection = false;
	    this.numFiltriAttivi = 0;
	    this.getCliccatori(); // Ricarica la lista senza filtri
		},
	 
		customSearch (filter, search, item) {
			if(search.trim() == '')
				return true; // Visualizza tutti
			
			// Nuova versione
			// Concatena nome e cognome per la ricerca combinata
			const nome = item.nome;
			const cognome = item.cognome;
      const nomeCompleto = `${nome} ${cognome}`.toLowerCase();
      const nomeCompletoInverso = `${cognome} ${nome}`.toLowerCase();
      const searchLower = search.toLowerCase();

			// Nota: se esiste un Team (perché si è in 'Tutti i cliccatori') allora cerca anche sul suo nome
			// Nota: cerca solo sulle colonne al momento visibili (nome e cognome considerati sempre assieme)

			return (
				(this.checkHeaderIsVisibile('nome') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (nome ?? '') === searchLower 
						: (nome ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('cognome') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (cognome ?? '') === searchLower 
						: (cognome ?? '').includes(searchLower))) ||
				((this.checkHeaderIsVisibile('nome') || this.checkHeaderIsVisibile('cognome')) && 
					(this.isRicercaMatchEsattoAbilitato 
						? (nomeCompleto ?? '') === searchLower 
						: (nomeCompleto ?? '').includes(searchLower))) ||
				((this.checkHeaderIsVisibile('nome') || this.checkHeaderIsVisibile('cognome')) && 
					(this.isRicercaMatchEsattoAbilitato 
						? (nomeCompletoInverso ?? '') === searchLower 
						: (nomeCompletoInverso ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('username') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (item.email?.toLowerCase() ?? '') === searchLower 
						: (item.email?.toLowerCase() ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('cellulare') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (item.cellulare?.toLowerCase() ?? '') === searchLower 
						: (item.cellulare?.toLowerCase() ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('codice_cliccatore') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (item.codice_cliccatore?.toString() ?? '') === searchLower 
						: (item.codice_cliccatore?.toString() ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('username') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (item.username?.toLowerCase() ?? '') === searchLower 
						: (item.username?.toLowerCase() ?? '').includes(searchLower))) ||
				(this.checkHeaderIsVisibile('team.nome') && 
					(this.isRicercaMatchEsattoAbilitato 
						? (item.team?.nome.toLowerCase() ?? '') === searchLower 
						: (item.team?.nome.toLowerCase() ?? '').includes(searchLower)))
			);

      // return (
			// 	((this.checkHeaderIsVisibile('nome') || this.checkHeaderIsVisibile('cognome')) && (nomeCompleto ?? '').includes(searchLower)) ||
			// 	((this.checkHeaderIsVisibile('nome') || this.checkHeaderIsVisibile('cognome')) && (nomeCompletoInverso ?? '').includes(searchLower)) ||
			// 	(this.checkHeaderIsVisibile('username') && (item.email?.toLowerCase() ?? '').includes(searchLower)) ||
			// 	(this.checkHeaderIsVisibile('cellulare') && (item.cellulare?.toLowerCase() ?? '').includes(searchLower)) ||
			// 	(this.checkHeaderIsVisibile('codice_cliccatore') && (item.codice_cliccatore?.toString() ?? '').includes(searchLower)) ||
			// 	(this.checkHeaderIsVisibile('username') && (item.username?.toLowerCase() ?? '').includes(searchLower)) ||
			// 	(this.checkHeaderIsVisibile('team.nome') && (item.team?.nome.toLowerCase() ?? '').includes(searchLower))
			// );

			// Vecchia versione (cercava su qualunque proprietà del cliccatore):
			// return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search.toLowerCase()))
		},
	  getInfoCliccatoriAttivi() {
			this.isLoadingInfoCliccatoriAttivi = true;
			axios.get('/infoCliccatoriAttivi')
				.then(response => {
					this.infoCliccatoriAttivi = response.data;
				})
				.finally(() => {
					this.isLoadingInfoCliccatoriAttivi = false;
				})
	  },
	  generaPassword() {
		  this.toEditCliccatore.passwordNC = GeneratePassword({
			  length: 12,
			  symbols: true,
		  });
	  },
	  downloadCsv() {
		  let csv = this.$papa.unparse(this.cliccatori, {
			  delimiter: ";",
			  header: true,
			  columns: [
				  'codice_cliccatore',
				  'nome',
				  'cognome',
				  'cellulare'
			  ]
		  });
		  
		  this.$papa.download(csv, 'Cliccatori')
	  },
	  apriGestioneIscrizioneInMassaAlClickdayDialog() {
			this.opzioneSelezionataPerGestioneIscrizioneInMassaAlClickday = null;
			this.gestioneIscrizioneInMassaAlClickdayDialog = true;
	  },
	  iscriviDisiscriviInMassa() {
			this.isLoadingIscriviDisiscriviInMassa = true;
			axios.post('/clickdayit/iscrivi-disiscrivi-in-massa', {
				opzione_selezionata: this.opzioneSelezionataPerGestioneIscrizioneInMassaAlClickday,
				cliccatori: this.cliccatori
			})
				.then(() => {
					this.gestioneIscrizioneInMassaAlClickdayDialog = false;
				})
				.finally(() => {
					this.isLoadingIscriviDisiscriviInMassa = false;
				})
	  }
  }
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

  ::v-deep .cliccatori-data-table .v-data-table__wrapper {
    font-weight: 600;
    color: #434343;
  }

  // ::v-deep .cliccatori-data-table .v-data-table-header tr th {
  ::v-deep .cliccatori-data-table thead tr th {
    border-bottom: none !important;
    height: 18px;
    font-size: 12px;
    color: #434343 !important;
    padding: 0 5px !important;
    &:hover {
      color: #6d94cd !important;
    }
    &:first-child {
      padding-left: 6px;
    }
    &:not(:last-child) {
      border-right: 1px solid #434343 !important;
    }
    &:not(:first-child) {
      // text-align: center !important;
    }
  }

  .cliccatori-data-table ._table_row {
    & td {
      padding: 0 4px;
    }
    &:not(:last-child) td {
      border-bottom: 1px solid #434343 !important;
    }
    & td:not(:last-child) {
      border-right: 1px solid #434343 !important;
    }
    & td:not(:first-child) {
      text-align: center;
    }
  }

  ::v-deep .v-input__slot {
    justify-content: center !important;
    margin-left: 5px !important;
    & .v-input--selection-controls__input {
      margin: 0 !important;
    }
  }

  ::v-deep .cliccatori-data-table .v-data-footer {
    border-top: none !important;
    & .v-data-footer__select {
      margin-left: 0 !important;
    }
  }

	::v-deep .v-select .v-chip {
		flex: 0 1 auto;
		margin: 4px;
	}

  ._pagina_cliccatori {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 14px;
    color: #434343 !important;
    font-weight: 400;
    line-height:1.5;
    padding-top: 20px;
		height: 100%;
  }

  ._box {
    // margin-bottom: 20px;
  }

  ._box_title {
    font-size: 16px;
    font-weight: 600;
    text-align:center;
    background-color: #6D94CD;
    padding: 5px;
    color:white
  }

  ._box_info {
    display: flex;
    padding: 15px 16px;
  }

  ._dati_squadra {
    font-weight: 600;
  }

  ._overlay {
    background-color: rgb(33, 33, 33, 0.46);
    border-color: rgb(33, 33, 33, 0.46);
    z-index:201;
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    width: 100%;
    height: 100%;
  }

  ._semi_bold {
    font-weight: 600;
  }
</style>
